import styled from 'styled-components';
import { media } from 'src/components/base';

import { TonalButton } from '@prisjakt/ui/button/variants';
import { Tooltip as TooltipComponent } from '@prisjakt/ui/tooltip';
import { BodySmallText } from '@prisjakt/ui/text/variants';

export const ListContainer = styled.ul`
  list-style: none;
  margin: 0;
`;

export const StyledTonalButton = styled(TonalButton)`
  width: 100px;

  ${media.mediumDown`
    width: 190px;
    background-color: white;
    justify-content: left;
  `}
`;

export const ButtonText = styled(BodySmallText)`
  ${media.mediumUp`
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  `}
`;

export const StyledTooltip = styled(TooltipComponent).attrs({
  width: '180px',
  'data-test': 'Tooltip',
})`
  flex: 0;
  width: 100%;
`;

export const ContentWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 0.25rem;

  ${media.mediumUp`
    white-space: nowrap;
    overflow: hidden;
  `}
`;
